import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-training-date',
  templateUrl: './change-training-date.component.html',
  styleUrls: ['./change-training-date.component.scss']
})
export class ChangeTrainingDateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
